export const toolsSuppliesLevelThree = [
    {
        "name": "Plier",
        "categoryId": "plier",
        "parentCategoryName": "Beading Tools",
        "parentCategoryId": "beading_tools",
        "level": 3
    },
    {
        "name": "Cutter",
        "categoryId": "cutter",
        "parentCategoryName": "Beading Tools",
        "parentCategoryId": "beading_tools",
        "level": 3
    },
    {
        "name": "Beading Needle",
        "categoryId": "beading_needle",
        "parentCategoryName": "Beading Tools",
        "parentCategoryId": "beading_tools",
        "level": 3
    },
    {
        "name": "Adhesive Gum",
        "categoryId": "adhesive_gum",
        "parentCategoryName": "Beading Tools",
        "parentCategoryId": "beading_tools",
        "level": 3
    },
    {
        "name": "Bag Frame",
        "categoryId": "bag_frame",
        "parentCategoryName": "Bag Making Accessories",
        "parentCategoryId": "bag_making_accessories",
        "level": 3
    },
    {
        "name": "Bag Chains",
        "categoryId": "bag_chains",
        "parentCategoryName": "Bag Making Accessories",
        "parentCategoryId": "bag_making_accessories",
        "level": 3
    },
    {
        "name": "O Ring",
        "categoryId": "o_ring",
        "parentCategoryName": "Bag Making Accessories",
        "parentCategoryId": "bag_making_accessories",
        "level": 3
    },
    {
        "name": "Locks",
        "categoryId": "locks",
        "parentCategoryName": "Bag Making Accessories",
        "parentCategoryId": "bag_making_accessories",
        "level": 3
    },
    {
        "name": "Lobsters",
        "categoryId": "lobsters",
        "parentCategoryName": "Bag Making Accessories",
        "parentCategoryId": "bag_making_accessories",
        "level": 3
    }
]